module.exports = __webpack_public_path__ + "img/waxlight-mobile.19fb6a05.webp";